export default __webpack_public_path__ + "static/media/VTorpedo.5ca1e02d.png";